import { Button } from '../../../../../../../components/Button/Button'
import { ContactLinkRow, type ContactLinkRowProps } from '../../ContactLinking/ContactLinkRow'

interface DeletableContactLinkRowProps extends ContactLinkRowProps {
  onDelete: () => void
  isDeleteDisabled?: boolean
  deleteLabel: string
}

export const DeletableContactLinkRow: React.FC<DeletableContactLinkRowProps> = ({ onDelete, isDeleteDisabled = false, deleteLabel, ...rowProps }) => (
  <div className='contact-link-grid__deletable-row'>
    <ContactLinkRow {...rowProps} />
    <div className='contact-link-grid__delete mb-3'>
      <Button type='button' variant='primaryGhost' className='p-2' aria-label={deleteLabel} onClick={onDelete} disabled={isDeleteDisabled}>
        <i className='bi bi-trash'></i>
      </Button>
    </div>
  </div>
)
